export default {
  'get-list': {
    method: 'post',
    url: '/commodity/history/list/ID'
  },
  'get-by-id': {
    method: 'get',
    url: '/commodity/history/ID'
  }
}
